// types/assistant.types.js
/**
 * Enums y constantes para Assistants
 * Centraliza los execution modes para modificarlos fácilmente
 */

/**
 * @typedef {'reactive' | 'react' | 'multiagent'} ExecutionMode
 */

/**
 * Enum de execution modes disponibles para assistants.
 * Los values son los que se envían al backend.
 */
export const ExecutionMode = Object.freeze({
  REACTIVE: 'reactive',
  REACT: 'react',
  MULTIAGENT: 'multiagent',
});

/**
 * Labels para mostrar en la UI por cada execution mode.
 */
export const ExecutionModeLabel = Object.freeze({
  [ExecutionMode.REACTIVE]: 'None',
  [ExecutionMode.REACT]: 'Simple',
  [ExecutionMode.MULTIAGENT]: 'Advanced',
});

/**
 * Descripciones opcionales para cada execution mode (tooltips, helpers, etc.)
 */
export const ExecutionModeDescription = Object.freeze({
  [ExecutionMode.REACTIVE]: 'Responds directly to user input without additional reasoning steps.',
  [ExecutionMode.REACT]: 'Uses tools step by step to complete tasks.',
  [ExecutionMode.MULTIAGENT]: 'Multi-agent orchestration. Coming soon.',
});

/**
 * Lista ordenada de execution modes para renderizar selects/dropdowns.
 * Cada item contiene value, label, description y disabled.
 */
export const EXECUTION_MODE_OPTIONS = [
  { value: ExecutionMode.REACTIVE, label: ExecutionModeLabel[ExecutionMode.REACTIVE], description: ExecutionModeDescription[ExecutionMode.REACTIVE], disabled: false },
  { value: ExecutionMode.REACT, label: ExecutionModeLabel[ExecutionMode.REACT], description: ExecutionModeDescription[ExecutionMode.REACT], disabled: false },
  { value: ExecutionMode.MULTIAGENT, label: ExecutionModeLabel[ExecutionMode.MULTIAGENT], description: ExecutionModeDescription[ExecutionMode.MULTIAGENT], disabled: true },
];

/** Execution mode por defecto */
export const DEFAULT_EXECUTION_MODE = ExecutionMode.REACTIVE;

/**
 * Helper: dado un value de execution mode, retorna su label.
 * @param {string} mode
 * @returns {string}
 */
export const getExecutionModeLabel = (mode) =>
  ExecutionModeLabel[mode] || mode || 'Unknown';
